import {useState} from 'react'
import MarketPlaceFeedCurrentUserProfile from './MarketPlaceFeedCurrentUserProfile'
import MarketPlaceFeedNavbar from './MarketPlaceFeedNavbar'
import MarketPlaceFeedHome from './MarketPlaceFeedHome'
import MarketPlaceFeedOpportunities from './MarketPlaceFeedOpportunities'
import { useSearchParams } from 'react-router-dom'
import IndustryProfiles from './IndependentResearcher/IndustryProfiles'

const MarketPlaceFeedLayout = () => {
  const [searchTerm,setSearchTerm] = useState("")
  const [searchResults,setSearchResults] = useState([])
  const [searchParams, setSearchParams] = useSearchParams();
   const [activeTab,setActiveTab] = useState("feed")
  return (
   <>
    <MarketPlaceFeedNavbar searchTerm={searchTerm} setSearchTerm={setSearchTerm} searchResults={searchResults} setSearchResults={setSearchResults} setSearchParams={setSearchParams}/>
     <div className="container mx-auto md:px-4 mt-6 mb-4">
    
          <div className="flex relative">
            <div className="hidden md:block w-1/4 px-2">
              <div className="sticky top-[80px] max-h-[calc(100vh-80px)] overflow-y-auto scrollbar-hidden">
                <MarketPlaceFeedCurrentUserProfile />
              </div>
            </div>
            {/* Center Section */}
            <div className="w-full md:w-2/4 md:px-2">
             <div className="sticky top-[80px] max-h-[calc(100vh-80px)] overflow-y-auto scrollbar-hidden">
               <div className="flex gap-4 w-full pb-4">
  <button onClick={()=>setActiveTab('feed')} className={`w-1/2 py-2 text-center ${activeTab === 'feed' ? 'bg-blue-500' :'bg-gray-200'} text-white rounded-[10px]`}>
    Feed
  </button>
  <button onClick={()=>setActiveTab('opportunity')} className={`w-1/2 py-2 text-center ${activeTab === 'opportunity' ? 'bg-blue-500' :'bg-gray-200'} text-white rounded-[10px]`}>
    Opportunity
  </button>
</div>
  {
            activeTab === 'feed' ?   <MarketPlaceFeedHome searchTerm={searchTerm} searchParams={searchParams} setSearchResults={setSearchResults}/> : <MarketPlaceFeedOpportunities/>
           }

              
              </div>
            </div>
            <div className="hidden md:block w-1/4 px-2">
              <div className="sticky top-[80px]  max-h-[calc(100vh-80px)] overflow-y-auto scrollbar-hidden">
                <IndustryProfiles/>
              </div>
            </div>
          </div>
        </div>
   </>
  )
}

export default MarketPlaceFeedLayout
